import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Fab,
  FormControlLabel,
  Grid,
  InputAdornment,
  Modal,
  Pagination,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EventIcon from "@mui/icons-material/Event";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

// import "react-datepicker/dist/react-datepicker.css";
import AddIcon from "@mui/icons-material/Add";

import AddReceipt from "./addReceipt";
import {
  getPaymentReceipt,
  getPaymentXlsx,
  getUnpaidUser,
} from "./paymentReceiptApi";
import ReceiptCart from "./receiptCard";
import { useEffect } from "react";
import axios from "../../utils/axios";
import {
  displayDateFormat,
  downloadXLSXFile,
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  payloadDateFormat,
} from "../../utils/commonUtils";
import { api } from "../../utils/api";
import { getPaymentRec } from "./paymentReceiptCustomApiHandler";
import { searchedElementDisplay } from "./receiptFunctions";
import UserCard from "./userCard";
import PaymentReceiptSearchModal from "./paymentReceiptSearchModal";
import { ToFromDate } from "../../common/toFromDate";
import Heading from "../../common/Heading";
const PaymentReceipt = () => {
  // const [SelectedEndDate, setSelectedEndDate] = useState(null);
  const [billFilter, setBillFilter] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(getEndOfMonth());
  const [SelectedStartDate, setSelectedStartDate] = useState(null);
  const [SelectedEndDate, setSelectedEndDate] = useState(null);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  // const [SelectedStartDate, setSelectedStartDate] = useState(
  //   getFirstDateOfMonth()
  // );
  const [endDate, setEndDate] = useState(
    getLastDateOfCurrentMonthPayloadFormat(),
  );

  const [startDateFormat, setstartDateFormat] = useState(
    getFirstDateOfCurrentMonthPayloadFormate(),
  );
  const [employeeDetail, setEmployeeDetail] = useState(null);

  const datePickerRef2 = useRef();

  const datePickerOnChange = (newValue) => {
    setSelectedStartDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDate(formattedDate2);

    // Update startDateFormat for API call
    setstartDateFormat(newValue.format("YYYY-MM-DD"));
    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const datePickerOnChangeEnd = (newValue) => {
    setSelectedEndDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDisplayEndDate(formattedDate2);

    // Update endDate for API call
    setEndDate(newValue.format("YYYY-MM-DD"));
    setEndDateOpen(false);
  };

  const [openT, setOpenT] = useState(true);
  const [open, setOpen] = useState(false);
  const [searchModal, setSearchModal] = useState(false);
  const [totals, setTotals] = useState();
  const [upPaidBillData, setUnPaidBillData] = useState();
  const [getPaymentObj, setGetPaymentObj] = useState({
    page: 1,
    pageSize: 12,
    // filter: "paymentmode",
    filter: "",

    search: billFilter,
    date: null,
  });
  const [selectedUser, setSelectedUser] = useState({
    name: "",
    mobile: "",
  });
  const [unPaidBill, setUnPaidBill] = useState([]);
  const data = {
    customerMobile: "",
    amount: 0,
    name: "",
    paymentMode: "cash",
    // paymentMod
  };
  const [billData, setBillData] = useState(data);

  const [searchReceiptsModal, setSearchReceiptsModal] = useState(false);
  const getUnpaid = async (param) => {
    await getUnpaidUser(param)
      .then((res) => {
        console.log("unPaid user", res?.data?.data);

        setUnPaidBillData([...res?.data?.data]);
      })
      .catch((err) => {});
  };
  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
    pageSize: 12,
  });
  const [numberOfRecords, setNumberOfRecords] = useState(1);
  const handleChange = (event, value) => {
    getPaymentRec(
      {
        date: startDateFormat,
        toDate: endDate,
        ...getPaymentObj,
        page: value,
        pageSize: pagination.pageSize,
        search: billFilter,
      },
      getPaymentReceipt,
      setNumberOfRecords,
      setTotals,
      totals,
      setReceipts,
    );
    setPagination({
      ...pagination,
      page: value,
    });
  };
  // const datePickerOnChange = (date) => {
  //   const dateStr = date.toLocaleDateString("en-GB", {
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //   });
  //   const dateStr2 = date.toLocaleDateString("en-GB", {
  //     year: "numeric",
  //     month: "long",
  //     day: "2-digit",
  //   });
  //   const [month, day, year] = dateStr.split("/");
  //   const formattedDate = `${year}-${day.padStart(2, "0")}-${month.padStart(
  //     2,
  //     "0"
  //   )}`;
  //   let dateContainer = String(dateStr2).split(" ");
  //   var year2 = dateContainer[2];
  //   var month2 = dateContainer[1];
  //   var day2 = dateContainer[0];
  //   var formattedDate2 = day2 + "-" + month2 + "-" + year2;
  //   datePickerRef2.current.setOpen(true);

  //   setDate(formattedDate2);
  //   setstartDateFormat(formattedDate);
  //   setSelectedStartDate(date);
  // };
  const [recepts, setReceipts] = useState([]);

  const [date, setDate] = useState();

  const [startDate, setStartDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  useEffect(() => {
    if (getPaymentObj?.date) {
      setSearch("");
      getPaymentRec(
        {
          ...getPaymentObj,
          page: pagination.page,
          date: startDateFormat,
          toDate: endDate,
          //   pageSize: pagination.pageSize,
          filter: billFilter != "" && billFilter !== null ? "paymentmode" : "",
          pageSize: 1000,
          search: search,
        },
        getPaymentReceipt,
        setNumberOfRecords,
        setTotals,
        totals,
        setReceipts,
      );
    }
  }, [getPaymentObj]);

  useEffect(() => {
    // downloadXLSXFile();
    console.log("datE ", date);
    getPaymentRec(
      {
        // ...getPaymentObj,
        // page: pagination.page,
        // pageSize: pagination.pageSize,
        date: startDateFormat,
        toDate: endDate,
        page: 1,
        pageSize: 1000,
        filter: null, //"filter": null,
        search: search,
        date: null,
      },
      getPaymentReceipt,
      setNumberOfRecords,
      setTotals,
      totals,
      setReceipts,
    );
  }, [startDateFormat, endDate]);

  return (
    <>
      <Box
        px={{ xs: 2, md: 2, lg: 4 }}
        pb={4}
        sx={{
          // paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container>
          <Heading name="Payment Receipt" />

          {/* <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontSize: { xs: "12px", sm: "13px", md: "15px", lg: "16px" },
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              fontSize={{ xs: "12px", sm: "13px", md: "15px", lg: "16px" }}
            >
              Payment Receipt
            </Typography>
          </Grid> */}
          <Grid container alignItems="center" spacing={{ md: 2, xs: 1 }}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Date"
                size="small"
                value={
                  SelectedStartDate && SelectedEndDate
                    ? `${SelectedStartDate.format(
                        "DD-MM-YYYY",
                      )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                    : SelectedStartDate
                      ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                      : ""
                }
                id="datepickerfield"
                placeholder="Select date range"
                InputLabelProps={{
                  shrink: !!search,
                  sx: {
                    fontWeight: 500,
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "15px",
                    },
                  },
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <EventIcon
                      sx={{
                        cursor: "pointer",
                        mr: 1,
                        fontSize: {
                          xs: "14px",
                          sm: "13px",
                          md: "15px",
                        },
                      }}
                      onClick={() => setStartDateOpen(true)}
                    />
                  ),
                  sx: {
                    background: "#fff",
                    borderRadius: 1,
                    cursor: "pointer",
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 500,
                  },
                }}
                onClick={() => setStartDateOpen(true)}
                sx={{ width: "100%" }}
              />

              <Box sx={{ position: "relative" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={startDateOpen}
                    onOpen={() => setStartDateOpen(true)}
                    onClose={() => setStartDateOpen(false)}
                    value={SelectedStartDate}
                    onChange={datePickerOnChange}
                    maxDate={SelectedEndDate || undefined}
                    slotProps={{
                      popper: {
                        placement: "bottom-end",
                        anchorEl: document.querySelector("#datepickerfield"),
                        sx: { zIndex: 1500 },
                      },
                      textField: { style: { display: "none" } },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={endDateOpen}
                    onOpen={() => setEndDateOpen(true)}
                    onClose={() => setEndDateOpen(false)}
                    value={SelectedEndDate}
                    onChange={datePickerOnChangeEnd}
                    minDate={SelectedStartDate || undefined}
                    slotProps={{
                      popper: {
                        placement: "bottom-start",
                        anchorEl: document.querySelector("#datepickerfield"),
                        sx: { zIndex: 1500 },
                      },
                      textField: { style: { display: "none" } },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={5}>
              {/* <TextField
                     fullWidth
                     id="name"
                     readonly
                     label="Search Name/Mobile Number"
                     value={search}
                     size="small"
                     onClick={() => {
                       setSearchOutStandingsModal(true)
                     }}
                     onChange={(e) => {
                       // setSearch(e.target.value);
                     }}
                     InputProps={{
                       style: {
                         margin: "0px",
                         // height: "45px"
                       },
                       endAdornment: (
                         <SearchIcon
                           onClick={() => {
                             setSearchOutStandingsModal(true)
                           }}
                           sx={{
                             color: (theme) => theme.palette.primary.main,
                             cursor: "pointer",
                           }}
                         />
                       ),
                     }}
                   /> */}
              <TextField
                fullWidth
                id="customer-name"
                label="Search Customer Name / Mobile No."
                value={search}
                size="small"
                onClick={() => setSearchReceiptsModal(true)}
                InputProps={{
                  readOnly: true,
                  sx: {
                    cursor: "pointer",
                    backgroundColor: "white",
                    borderRadius: "4px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    // Input text and placeholder font size
                    "& input": {
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                      },
                      padding: "10.5px 14px", // Adjust as needed for vertical alignment
                    },
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      {search ? (
                        <CloseIcon
                          sx={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSearch("");
                            setBillFilter("");
                            setPagination((prev) => ({ ...prev, page: 1 }));
                            getPaymentRec(
                              {
                                date: startDateFormat,
                                toDate: endDate,
                                page: 1,
                                pageSize: 12,
                                filter: null,
                                search: "",
                                date: null,
                              },
                              getPaymentReceipt,
                              setNumberOfRecords,
                              setTotals,
                              totals,
                              setReceipts,
                            );
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <SearchIcon
                            onClick={() => setSearchReceiptsModal(true)}
                            sx={{
                              color: (theme) => theme.palette.primary.main,
                              cursor: "pointer",
                              fontSize: {
                                xs: "14px",
                                sm: "13px",
                                md: "15px",
                              },
                            }}
                          />
                        </Box>
                      )}
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  shrink: !!search,
                  sx: {
                    fontWeight: 500,
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "15px",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} sx={{ pt: "10px" }}>
              <RadioGroup
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: {
                    xs: "row", // vertical stacking on small screens
                    sm: "row",
                    md: "row",
                    lg: "column", // horizontal from small screens and up
                  },
                }}
                value={billFilter}
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                onChange={(e) => {
                  setSearch("");
                  getPaymentRec(
                    {
                      ...getPaymentObj,
                      page: pagination.page,
                      pageSize: 1000,
                      date: startDateFormat,
                      toDate: endDate,
                      filter: "paymentmode",
                      search: e.target.value,
                    },
                    getPaymentReceipt,
                    setNumberOfRecords,
                    setTotals,
                    totals,
                    setReceipts,
                  );
                  setBillFilter(e.target.value);
                }}
              >
                <FormControlLabel
                  value="cash"
                  control={<Radio />}
                  label="Cash Payment"
                  sx={{
                    mr: { sm: 2 }, // spacing between buttons horizontally
                    mb: { xs: 0, sm: 0 }, // spacing vertically on mobile
                    ".MuiFormControlLabel-label": {
                      fontWeight: 500,
                      color: "#000000",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    },
                  }}
                />
                <FormControlLabel
                  value="online"
                  control={<Radio />}
                  label="Online Payment"
                  sx={{
                    mr: { sm: 2 },
                    mb: { xs: 0, sm: 0 },
                    ".MuiFormControlLabel-label": {
                      fontWeight: 500,
                      color: "#000000",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    },
                  }}
                />
              </RadioGroup>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={{ md: 2, xs: 1, sm: 0 }}
            sx={{
              padding: { md: "12px 10px", sm: "1px", xs: "5px" },
              borderRadius: "8px",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              rowGap: 0,
            }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                gap: { md: 1, sm: 1, xs: 1 },
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#CCCCFF",
                  padding: { md: "6px 12px", sm: "4px 8px", xs: "4px 8px" },
                  borderRadius: "8px",
                  fontWeight: 500,
                  color: "#00008B",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "15px",
                    },
                  }}
                >
                  Total Recovery (₹):&nbsp;&nbsp;&nbsp;
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 600,
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "15px",
                    },
                  }}
                >
                  {(totals?.totalRecovery ?? 0).toFixed(2)}
                </Typography>
              </Box>

              <Box
                sx={{
                  backgroundColor: "#CCCCFF",
                  padding: { md: "6px 12px", sm: "4px 8px", xs: "4px 8px" },
                  borderRadius: "8px",
                  fontWeight: 500,
                  color: "#00008B",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "15px",
                    },
                  }}
                >
                  Total Receipt:&nbsp;&nbsp;&nbsp;
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 600,
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "15px",
                    },
                  }}
                >
                  {totals?.totalReceipts ?? 0}
                </Typography>
              </Box>
            </Grid>

            <Grid item>
              <Box
                sx={{ display: "flex", gap: { lg: 3, md: 1, sm: 1, xs: 1 } }}
              >
                <Button
                  onClick={() => {
                    setOpen(true);
                    setSearch("");
                  }}
                  sx={{
                    height: { md: "40px", xs: "30px" },
                    backgroundColor: "#14008B",
                    paddingX: { md: "30px", sm: "10px", xs: "20px" },
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "14px",
                      lg: "15px",
                    },
                  }}
                  size="medium"
                  color="primary"
                  variant="contained"
                  aria-label="add"
                >
                  Add Receipt
                  <AddIcon sx={{ ml: 1 }} />
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    height: { md: "40px", xs: "30px" },
                    backgroundColor: "#14008B",
                    paddingX: { md: "30px", sm: "10px", xs: "20px" },
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "12px",
                      sm: "13px",
                      md: "14px",
                      lg: "15px",
                    },
                  }}
                  onClick={() => {
                    downloadXLSXFile(
                      api + "CounterSales/GetPaymentReceiptsXlsx",
                      {
                        filter: getPaymentObj.filter,
                        search: getPaymentObj.search,
                        date: getPaymentObj.date,
                      },
                    );
                  }}
                  endIcon={<DownloadIcon />}
                >
                  Download
                </Button>
              </Box>
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              p: { xs: "1px", sm: "10px" },

              mt: 2,
              background: "white",
              borderRadius: "12px",
              overflowX: "auto",
            }}
          >
            <Box sx={{ minWidth: "600px", width: "100%" }}>
              <Grid container>
                {/* Header */}
                <Grid item xs={12}>
                  <Grid
                    container
                    sx={{
                      borderBottom: "1.5px solid black",
                      padding: "10px",
                    }}
                  >
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                          fontWeight: 500,
                          color: "#01008B",
                        }}
                      >
                        Bill No.
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                          fontWeight: 500,
                          color: "#01008B",
                        }}
                      >
                        Customer Name
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                          fontWeight: 500,
                          color: "#01008B",
                        }}
                      >
                        Date
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                          fontWeight: 500,
                          color: "#01008B",
                        }}
                      >
                        Mobile No.
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                          fontWeight: 500,
                          color: "#01008B",
                        }}
                      >
                        Payment Mode
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                          fontWeight: 500,
                          color: "#01008B",
                        }}
                      >
                        Total
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{
                    height: "60vh",
                    overflowY: "auto",
                    marginTop: "10px",
                    padding: "15px",
                  }}
                >
                  {recepts
                    ?.filter((ele) => {
                      if (!selectedUser.name || !selectedUser.mobile)
                        return true; // show all if no user selected

                      return (
                        ele?.customer?.toLowerCase() ===
                          selectedUser.name?.toLowerCase() &&
                        ele?.customerMobile === selectedUser.mobile
                      );
                    })
                    .map((item, i) => {
                      return (
                        <Grid
                          container
                          key={"payamentRecpt" + i}
                          sx={{
                            p: "8px 0",
                            borderBottom: "1px solid #eee",
                            alignItems: "center",
                            backgroundColor: "#E8E8FF",
                            borderRadius: "8px",
                            mb: 1,
                          }}
                        >
                          <Grid
                            item
                            xs={2}
                            sx={{ pr: { xs: 5, sm: 4, lg: 10 } }}
                          >
                            <Typography
                              sx={{
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {item?.id || "-"}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{ pl: { xs: 2, sm: 2, lg: 4 } }}
                          >
                            <Typography
                              sx={{
                                textAlign: "left",
                                fontWeight: "500",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {item?.customer || "-"}
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              sx={{
                                textAlign: "center",
                                fontWeight: "500",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {convertDateToCustomFormat(
                                item?.date?.split("T")[0],
                              ) || "-"}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{ pr: { xs: 1, sm: 1, lg: 6 } }}
                          >
                            <Typography
                              sx={{
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {item?.customerMobile || "-"}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{ pl: { xs: 2, sm: 2, lg: 4 } }}
                          >
                            <Typography
                              sx={{
                                textAlign: "left",
                                fontWeight: "500",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {item?.paymentMode === "cash"
                                ? "Cash Payment"
                                : item?.paymentMode === "online"
                                  ? "Online Payment"
                                  : item?.paymentMode}
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Box p={1} px={{ xs: 2, sm: 2, md: 4, lg: 7 }}>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                  width: "100%",
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                }}
                              >
                                <CurrencyRupeeIcon
                                  sx={{
                                    fontSize: "16px",
                                    color: "#000",
                                    fontSize: {
                                      xs: "12px",
                                      sm: "13px",
                                      md: "15px",
                                    },
                                  }}
                                />
                                <Typography
                                  fontWeight={500}
                                  align="right"
                                  sx={{
                                    flex: 1,
                                    textAlign: "right",
                                    fontSize: {
                                      xs: "12px",
                                      sm: "13px",
                                      md: "15px",
                                    },
                                  }}
                                >
                                  {item?.amount?.toFixed(2)}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      );
                    })}
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* <Grid
        container
        sx={{
          p: "20px",
        }}
      > */}
      {/* <Grid
          item
          xs={12}
          sm={6}
          sx={{
            display: "flex",
            justifyContent: "right",
          }}
        > */}
      {/* <ToFromDate
            startDateFormat={startDateFormat}
            setstartDateFormat={setstartDateFormat}
            endDate={endDate}
            setEndDate={setEndDate}
          /> */}

      {/* <DatePicker
          hidden={true}
          selected={SelectedStartDate}
          maxDate={new Date()}
          onChange={datePickerOnChange}
          className="custom-datepicker"
          ref={datePickerRef}
          onClickOutside={() => {
            datePickerRef.current.setOpen(false);
          }}
        />

        <DatePicker
          hidden={true}
          selected={SelectedEndDate}
          maxDate={new Date()}
          onChange={datePickerOnChangeEnd}
          className="custom-datepicker"
          ref={datePickerRef2}
          onClickOutside={() => {
            datePickerRef2.current.setOpen(false);
          }}
        /> */}

      {/* <DatePicker
            hidden={true}
            selected={startDate}
            maxDate={new Date()}
            onChange={(date) => {
              const dateStr = date.toLocaleDateString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              });
              const dateStr2 = date.toLocaleDateString("en-GB", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              });
              const [month, day, year] = dateStr.split("/");

              const formattedDate = `${year}-${day.padStart(
                2,
                "0"
              )}-${month.padStart(2, "0")}`;

              setGetPaymentObj({ ...getPaymentObj, date: formattedDate });

              let dateContainer = String(dateStr2).split(" ");
              var year2 = dateContainer[2];
              var month2 = dateContainer[1];
              var day2 = dateContainer[0];
              var formattedDate2 = day2 + "-" + month2 + "-" + year2;
              setDate(formattedDate2);

              setStartDate(date);
            }}
            className="custom-datepicker"
            ref={datePickerRef}
            onClickOutside={() => datePickerRef.current.setOpen(false)}
          /> */}
      {/* </Grid> */}
      {/* <Grid
          item
          xs={12}
          sm={6}
          sx={{
            pt: {
              xs: "10px",
              sm: "0px",
            },
            padding: { sm: "0px 16px" },

            // fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
          }}
        >
          <Box
            // disabled
            // size="small"
            readonly
            fullWidth
            onClick={() => {
              setSearchReceiptsModal(true);
            }}
            // id="name"
            // label="Search by Name/Mobile Number"
            // value={search}
            sx={{
              display: "flex",
              height: "23px",
              justifyContent: "space-between",
              width: "70%",
              border: "1px solid #c9c9c9",
              p: 1,
              borderRadius: "4px ",
              color: "grey",
              "&:hover": {
                cursor: "pointer !important",
              },
            }}
            onChange={(e) => {
              // setSearch(e.target.value);
            }}
            // InputProps={{
            //   style: {
            //     // background:"yellow"
            //     cursor: 'pointer !important',
            //     '&:hover': {
            //       cursor: 'pointer !important', // Set the cursor to pointer on hover
            //       // Add other hover styles here if needed
            //     },
            //     height: "40px"
            //   },

            // }}
          >
            <Typography variant="p">
              {search !== "" ? search : "Search by Name/Mobile Number"}
            </Typography>
            <SearchIcon
              onClick={() => {
                // setSearchModal(true)
                setSearchReceiptsModal(true);
              }}
              sx={{
                color: (theme) => theme.palette.primary.main,
                cursor: "pointer",
              }}
            />
          </Box>

          <FileDownloadIcon
            sx={{ ml: "10px", mr: "0px", cursor: "pointer" }}
            onClick={() => {
              console.log("call ", {
                filter: getPaymentObj.filter,
                search: getPaymentObj.search,
                date: getPaymentObj.date,
              });

              downloadXLSXFile(api + "CounterSales/GetPaymentReceiptsXlsx", {
                filter: getPaymentObj.filter,
                search: getPaymentObj.search,
                date: getPaymentObj.date,
              });
            }}
          />
        </Grid> */}
      {/* <Grid
          item
          xs={4}
          sx={{
            pt: "10px",
          }}
        >
          <RadioGroup
            row
            sx={{
              fontWeight: "500",
              //   justifyContent: "space-around",
              width: "100%",
            }}
            value={billFilter}
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            // value={bill.paymentMode}
            onChange={(e) => {
              setSearch("");
              getPaymentRec(
                {
                  ...getPaymentObj,
                  page: pagination.page,
                  pageSize: 12,
                  date: startDateFormat,
                  toDate: endDate,
                  filter: "paymentmode",
                  search: e.target.value,
                },
                getPaymentReceipt,
                setNumberOfRecords,
                setTotals,
                totals,
                setReceipts
              );
              setBillFilter(e.target.value);
            }}
          >
            <FormControlLabel
              value="cash"
              control={<Radio />}
              label="Cash Payment"
            />
            <FormControlLabel
              value="online"
              control={<Radio />}
              label="Online Payment"
            />
          </RadioGroup>
        </Grid> */}
      {/* <Grid
          item
          xs={6}
          sx={{
            padding: "8px 16px",
            fontWeight: "500",
          }}
        >
          <Box
            component="span"
            sx={{ color: (theme) => theme.palette.primary.main }}
          >
            Total Recovery:
          </Box>
          <Box
            component="span"
            sx={{
              marginLeft: "8px",
              color: (theme) => theme.palette.secondary.main,
            }}
          >
            {totals?.totalRecovery?.toFixed(2)}
          </Box>
        </Grid> */}
      {/* <Grid
          item
          xs={6}
          sx={{
            padding: "8px 16px",
            fontWeight: "500",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Box
              component="span"
              sx={{
                color: (theme) => theme.palette.primary.main,

                fontWeight: "500",
              }}
            >
              Total Receipt:{" "}
            </Box>
            <Box
              component="span"
              sx={{
                marginLeft: "8px",
                color: (theme) => theme.palette.secondary.main,
              }}
            >
              {totals?.totalReceipts}
            </Box>
          </Box>
          <Fab
            onClick={() => {
              // setOpen(true);
              setOpen(true);
            }}
            sx={{
              textTransform: "capitalize",
              width: {
                xs: "100%",
                sm: "auto",
              },
              // p: "10px",
              whiteSpace: "nowrap",
            }}
            size="small"
            color="primary"
            variant="extended"
            aria-label="add"
          >
            Add Receipt
            <AddIcon />
          </Fab>
        </Grid> */}
      {/* <Divider /> */}

      {/* <Divider
          sx={{
            width: "100%",
            background: (theme) => theme.palette.primary.main,
          }}
        /> */}
      {/* <ReceiptCart /> */}
      {/* <AddCircleIcon
          color="primary"
          onClick={async () => {
            setOpen(true);
          }}
          sx={{
            fontSize: "60px",
            cursor: "pointer",
            position: "fixed",
            bottom: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        /> */}
      {/* <Grid container>
          {recepts?.map((item, i) => {
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={4}
                key={"payamentRecpt" + i}
                sx={{ p: "3px", borderRight: "3px solid #dfdfdf" }}
              >
                <ReceiptCart item={item} />
              </Grid>
            );
          })}
        </Grid> */}
      <AddReceipt
        open={open}
        recepts={recepts}
        setOpen={setOpen}
        getRecept={() => {
          console.log("Payment saved ss");
          getPaymentRec(
            {
              ...getPaymentObj,
              page: pagination.page,
              pageSize: pagination.pageSize,
              date: startDateFormat,
              toDate: endDate,
              search: billFilter,
            },
            getPaymentReceipt,
            setNumberOfRecords,
            setTotals,
            totals,
            setReceipts,
          );
        }}
        unPaidBill={unPaidBill}
        setUnPaidBill={setUnPaidBill}
        upPaidBillData={upPaidBillData}
        setUnPaidBillData={setUnPaidBillData}
        billData={billData}
        setBillData={setBillData}
        searchModal={searchModal}
        setSearchModal={setSearchModal}
      />
      <Modal
        open={searchModal}
        sx={{ zIndex: 999999 }}
        onClose={() => {
          setSearchModal(false);
          setSearch("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Grid
          container
          sx={{
            background: "white",
            width: { xs: "95%", sm: "85%", md: "70%", lg: "60%", xl: "50%" },

            overflowY: "auto",
            height: "70vh",
            position: "absolute",
            left: { xs: "2%", sm: "5%", md: "10%", lg: "15%", xl: "20%" },

            top: "5%",
          }}
        >
          <Grid item xs={12} sx={{ p: 2 }}>
            <CloseIcon
              sx={{
                float: "right",
                cursor: "pointer",
                color: (theme) => theme.palette.primary.main,
              }}
              onClick={() => {
                setSearchModal(false);
                setSearch("");
              }}
            />
            <Box sx={{ mt: 2, mb: 2 }}>
              <TextField
                fullWidth
                size="small"
                sx={{ width: "100%" }}
                label="Search by Name/Mobile Number"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <SearchIcon
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                      }}
                    />
                  ),
                }}
              />
            </Box>

            <Box sx={{ height: "52vh", overflowY: "auto", pr: 1 }}>
              {[...unPaidBill]
                .sort((a, b) =>
                  a?.name?.toLowerCase().localeCompare(b?.name?.toLowerCase()),
                )
                .map((item, index) => {
                  if (
                    searchedElementDisplay(
                      { ...item, mobile: item?.customerMobile || "" },
                      search,
                    )
                  ) {
                    return null;
                  }

                  return (
                    <UserCard
                      key={index}
                      data={item}
                      callBack={() => {
                        console.log("item ", item);
                        getUnpaid({
                          customerMobile: item?.customerMobile,
                        });
                        setBillData({
                          ...item,
                          customerMobile: item?.mobile,
                          customer: item?.name,
                        });
                        setSearchModal(false);
                        setSearch("");
                      }}
                    />
                  );
                })}
            </Box>
          </Grid>
        </Grid>
      </Modal>

      <PaymentReceiptSearchModal
        searchModal={searchReceiptsModal}
        setSelectedUser={setSelectedUser}
        setSearchModal={setSearchReceiptsModal}
        unPaidBill={unPaidBill}
        getUnpaid={getUnpaid}
        setBillData={setBillData}
        search={search}
        setSearch={setSearch}
        setUSerObject={() => {}}
        setUnPaidBill={setUnPaidBill}
        setUnPaidBillData={setUnPaidBillData}
        setPagination={setPagination}
        billData={billData}
        callSearchApi={(searchValue) => {
          const isMobile = /^\d{10}$/.test(searchValue);
          const filterType = isMobile ? "buyermobile" : "buyername";

          setBillFilter("");
          getPaymentRec(
            {
              ...getPaymentObj,
              page: pagination.page,
              date: startDateFormat,
              toDate: endDate,
              //   pageSize: pagination.pageSize,
              filter: filterType,
              pageSize: 12,
              search: search,
            },
            getPaymentReceipt,
            setNumberOfRecords,
            setTotals,
            totals,
            setReceipts,
          );
        }}
        //  userDetail={userDetail}
      />
      {/* ------------------------------------------------------ */}

      {/* <Grid container sx={{ pt: "10px" }}>
          <Grid item xs={4}></Grid>
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Pagination
              count={
                Number.isInteger(numberOfRecords / pagination.pageSize)
                  ? numberOfRecords / pagination.pageSize
                  : parseInt(numberOfRecords / pagination.pageSize) + 1
              }
              page={pagination.page}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid> */}
      {/* ------------------------------- */}
      {/* </Grid> */}
      {/* </Box> */}
      {/* </Drawer> */}
    </>
  );
};

export default PaymentReceipt;
